module.exports = __webpack_public_path__ + "901daeaa8c640f4cc2dbadec0c2362a7.png";